/**
 * @poc-to-production
 *
 * FormaApp — the Forma-embedded demo (#/forma). Two screens:
 *
 *   1. FormaFilesScreen — the Forma "Data Management → Files" landing the
 *      demo opens on. No Vera content yet: just the file list (NYC Snowdon
 *      Towers + LA Casita Blanca). Selecting a model reveals the "Vera"
 *      button next to "Upload files".
 *   2. FormaVeraView — the live Vera analysis (SheetViewer + Requirements +
 *      Violations) in the Forma chrome, scoped to the picked project.
 *
 * Clicking "Check with Vera" sets the current project and switches to (2);
 * the "‹ Files" affordance in the sub-bar returns to (1). This mirrors how
 * Vera would actually live inside Forma: a button on a file, not a
 * pre-loaded panel.
 */
import { useState } from "preact/hooks";
import { getProject } from "../../data/projects";
import { useAccBrowseStore } from "../../stores/accBrowseStore";
import { useProjectStore } from "../../stores/projectStore";
import { useViewerStore } from "../../stores/viewerStore";
import { FormaFilesScreen } from "./FormaFilesScreen";
import { FormaVeraView } from "./FormaVeraView";

export function FormaApp() {
  const [screen, setScreen] = useState<"files" | "vera">("files");
  const setCurrentProject = useProjectStore(s => s.setCurrentProject);
  const setCurrentSheet = useViewerStore(s => s.setCurrentSheet);
  const setAccSelection = useAccBrowseStore(s => s.setSelection);

  if (screen === "files") {
    return (
      <FormaFilesScreen
        onOpenVera={target => {
          if (typeof target === "string") {
            setAccSelection(null);
            setCurrentProject(target);
            setCurrentSheet(getProject(target).defaultSheetId);
          } else {
            setAccSelection(target);
            // Live ACC path — engine loads from viewer extraction, not demo bundle.
          }
          setScreen("vera");
        }}
      />
    );
  }
  return <FormaVeraView onBackToFiles={() => setScreen("files")} />;
}
